import { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";

import "./style.css";
import Request from "../button/Request";
import FaqSection from "../Accordion/Accordion";
import { BlogApi } from "../../api/blog";

const TrustCenter = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const { data } = await BlogApi({ page: 1, limit: 5 });
        if (data?.status) {
          const formattedData = data?.data?.blogs?.map((item) => ({
            id: item?.id,
            slug: item?.slug,
            title: item?.title,
            status: item?.status,
            desc: item?.desc,
            image: item?.image,
            created_at: new Date(item?.date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            }),
          }));
          setBlogs(formattedData?.filter((item) => item?.status === "active") || []);                                                                          
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchBlogs();
  }, []);
   const FAQData = [
     {
      question: "Can you share your organization's security policies?",
      answer:
        "Yes. TrackMyDoc maintains comprehensive security and privacy policies covering data protection, access control, and risk management. These are available upon request for compliance and due diligence purposes.",
    },
    {
      question: "Do you have a formal incident response policy?",
      answer:
        "Yes. TrackMyDoc follows a structured incident response framework that includes detection, containment, resolution, and reporting — ensuring minimal disruption and full transparency in case of any security event.",
    },
    {
      question: "Is TrackMyDoc ISO/IEC 27001 certified?",
      answer:
        "TrackMyDoc aligns with ISO/IEC 27001 security standards and follows best practices for managing and securing sensitive financial data through a robust ISMS framework.",
    },
    {
      question: "Is TrackMyDoc compliant with Canadian data protection laws?",
      answer:
        "Yes. TrackMyDoc is designed to support compliance with PIPEDA, ensuring proper handling, storage, and protection of personal information.",
    },
    {
      question: "How does TrackMyDoc protect sensitive financial documents?",
      answer:
        "TrackMyDoc uses end-to-end encryption, secure cloud storage, role-based access controls, and continuous monitoring to ensure that all documents remain protected at every stage of the workflow.",
    },
    {
      question: "Where is client data stored?",
      answer:
        "TrackMyDoc uses secure, compliant cloud infrastructure with strict access controls and data protection measures. Data residency and handling practices align with regulatory requirements.",
    },
  ];
  return (
    <div>
      {/* Hero Section */}
      <div className="hero-section py-sm-5 py-3">
        <div className="website-container">
          <div className="__text text-center">
            <h2 className="mb-12">
              <span className="primary-color">TrackMyDoc</span> Trust Center
            </h2>
            <p className="f-18 mx-707">
              At TrackMyDoc, safeguarding sensitive financial documents isn't a feature — it's the foundation. <br/> We help CPA, CA, and immigration agents operate with confidence by implementing enterprise-grade security, strict compliance protocols, and continuous system monitoring. Every document, every client interaction, and every workflow is protected by design.
            </p>
          </div>
        </div>
      </div>

      {/* How TMD approaches security */}
      <div className="tc-approach-section">
        <div className="tc-approach-top">
          <div className="website-container">
            <h2 className="text-center mb-0 text-white">
              How <span className="primary-color">TrackMyDoc</span> Approaches Security
            </h2>
          </div>
        </div>
        <div className="pb-4">
          <div className="website-container">
            <Row className="g-4 justify-content-center tc-cards-row">
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon1.svg"
                      alt="Privacy"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Privacy</h5>
                  </div>
                  <p>
                    We prioritize client confidentiality with strict data governance policies. Your financial documents and client records are encrypted, access-controlled, and handled in accordance with applicable data protection standards.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon2.svg"
                      alt="Security"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Security</h5>
                  </div>
                  <p>
                    TrackMyDoc is built on a multi-layered security architecture — combining secure cloud infrastructure, role-based access control, end-to-end encryption, and continuous threat monitoring to protect your firm and your clients.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon3.svg"
                      alt="Compliance"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Compliance</h5>
                  </div>
                  <p>
                    We align with globally recognized and region-specific compliance frameworks to ensure your firm meets regulatory obligations without operational complexity.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={3}>
                <div className="tc-card">
                  <div className="d-flex align-items-center mb-3">
                    <img
                      src="/tc-icon4.svg"
                      alt="Status"
                      className="tc-card-icon me-3"
                    />
                    <h5 className="mb-0 text-lg fw-600">Status & Transparency</h5>
                  </div>
                  <p>
                    Stay informed with real-time system performance, uptime monitoring, and proactive alerts — ensuring complete transparency and reliability for your practice.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>

      {/* Certifications and attestations */}
      <div className="tc-cert-section">
        <div className="tc-cert-top">
          <div className="website-container">
            <div className="text-center">
              <h2 className="mb-12">Certifications & Compliance</h2>
              <p className="mx-707 mx-auto">
                TrackMyDoc adheres to globally recognized security standards and privacy regulations — helping CPA, CA, and immigration agents maintain compliance with confidence.
              </p>
            </div>
          </div>
        </div>
        <div className="tc-cert-bottom">
          <div className="tc-cert-border">
            <div className="website-container">
              <Row className="justify-content-center tc-cert-row">
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate1.svg"
                        alt="GDPR"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">GDPR</h5>
                    <p className="mx-auto">
                      The General Data Protection Regulation (GDPR) ensures strict protection of personal data and privacy. TrackMyDoc follows GDPR principles to ensure transparent data handling, secure processing of sensitive financial information, and strong data subject rights and controls. This makes TrackMyDoc a globally compliant platform for firms handling international clients.
                    </p>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate2.svg"
                        alt="ISO/IEC 27001"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">ISO/IEC 27001</h5>
                    <p className="mx-auto">
                      ISO/IEC 27001 is the gold standard for information security management systems (ISMS). TrackMyDoc aligns with ISO 27001 practices to identify and mitigate security risks, implement structured data protection controls, and continuously improve security processes. This ensures your firm operates on a platform built with systematic, audited security practices.
                    </p>
                  </div>
                </Col>
                <Col xs={12} md={4} className="text-center">
                  <div className="tc-cert-item">
                    <div className="tc-cert-img-wrap">
                      <img
                        src="/certificate3.svg"
                        alt="PIPEDA"
                        className="tc-cert-img"
                      />
                    </div>
                    <h5 className="mb-0 text-lg fw-600">PIPEDA (Canada)</h5>
                    <p className="mx-auto mb-0">
                      The Personal Information Protection and Electronic Documents Act (PIPEDA) governs how private-sector organizations handle personal data in Canada. TrackMyDoc supports PIPEDA compliance by ensuring lawful data collection and usage, protecting client information with strict safeguards, and enabling accountability and transparency in data handling. Built to support compliance-driven workflows, TrackMyDoc helps you stay aligned with Canadian privacy regulations.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-section pattern-line2 lg:pt-16 pt-12">
        <div className="__text text-center res-mb-40 mt-0">
          <h1 className="mb-12 leading-normal text-[40px] max-xl:text-[27px] max-md:text-[20px]">
            The most effective platform for <br />
            <span className="primary-color mt-2">
              CPAs, Insurance Agents, and Immigration Consultants.
            </span>
          </h1>
          <p className="f-18 mb-20">
            Empower and manage your teams with an AI-powered CRM platform.
          </p>
          <div className="flex justify-center gap-4">
            <Request />
            {/* <button className="btn btn-outline-primary">
                    Start Free Trial
                  </button> */}
          </div>
        </div>
      </div>
      {/* Blogs Section */}
      {blogs.length > 0 && (
        <div className="tc-blogs-section">
          <div className="website-container">
            <div className="pb-xl-5 pb-lg-4 pb-3 tc-blogs-header text-center">
              <h2 className="text-white mb-12">Blogs</h2>
              <p className="text-white mx-auto" style={{ opacity: 0.7 }}>
                Learn more about our security approach.
              </p>
            </div>
            <div className="tc-blogs-slider-wrap">
              {blogs.length <= 3 ? (
                <Row className="g-3 justify-content-start">
                  {blogs.map((item) => (
                    <Col key={item.id} xs={12} sm={6} lg={4}>
                       <Link to={`/blog/${item.slug}`}>
                      <div className="tc-blog-card">
                        <div className="tc-blog-img-wrap">
                          <img src={item.image || "/blog.png"} alt="Blog" className="tc-blog-img" />
                        </div>
                        <div className="tc-blog-content">
                          <h5 className="fw-600 mb-2">
                            {item.title}
                          </h5>
                          <p className="tc-blog-desc">
                            <span dangerouslySetInnerHTML={{ __html: item.desc }} />
                            <Link to={`/blog/${item.slug}`} className="primary-color fw-600">
                              Read More
                            </Link>
                          </p>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="tc-blog-date">{item.created_at}</span>
                            <Link to={`/blog/${item.slug}`}>
                              <img src="/topright-arroe.png" alt="arrow" className="tc-blog-arrow-img" />
                            </Link>
                          </div>
                        </div>
                      </div>
                      </Link>
                    </Col>
                  ))}
                </Row>
              ) : (
                <Slider
                  {...{
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    prevArrow: (
                      <button type="button" className="slick-prev">
                        <img src="/right-arrow.png" alt="Previous" className="tc-slider-arrow-img" style={{ transform: "scaleX(-1)" }} />
                      </button>
                    ),
                    nextArrow: (
                      <button type="button" className="slick-next">
                        <img src="/right-arrow.png" alt="Next" className="tc-slider-arrow-img" />
                      </button>
                    ),
                    responsive: [
                      {
                        breakpoint: 991,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 1,
                        },
                      },
                    ],
                  }}
                >
                  {blogs.map((item) => (
                    <div key={item.id} className="px-2">
                        <Link to={`/blog/${item.slug}`}>
                      <div className="tc-blog-card">
                        <div className="tc-blog-img-wrap">
                          <img src={item.image || "/blog.png"} alt="Blog" className="tc-blog-img" />
                        </div>
                        <div className="tc-blog-content">
                          <h5 className="fw-600 mb-2">
                            {item.title}
                          </h5>
                          <p className="tc-blog-desc">
                            <span dangerouslySetInnerHTML={{ __html: item.desc }} />
                            <Link to={`/blog/${item.slug}`} className="primary-color fw-600">
                              Read More
                            </Link>
                          </p>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="tc-blog-date">{item.created_at}</span>
                            <Link to={`/blog/${item.slug}`}>
                              <img src="/topright-arroe.png" alt="arrow" className="tc-blog-arrow-img" />
                            </Link>
                          </div>
                        </div>
                      </div>
                      </Link>
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          </div>
        </div>
      )}
        <FaqSection
        data={FAQData}
        subTitle=""
        Title="Frequently Asked Questions"
      />
      {/* Get Help CTA Section */}
      <div className="tc-cta-section">
        <div className="website-container">
          <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between flex-wrap">
            <div className="d-flex flex-lg-row flex-column align-items-center justify-content-center text-center text-lg-start mb-2 mb-lg-0">
              <img src="/cta-icon.svg" alt="Support" className="tc-cta-icon me-4 mb-3" />
              <div>
                <h2 className="text-white fw-700 mb-3">Get help on Trust Center usage</h2>
                <p className="text-white mb-0 tc-cta-desc">
                  If you need help using the Trust Center or want to learn more about
                  our security measures, please contact our Support Team.
                </p>
              </div>
            </div>
            <Link to="/contact" className="tc-cta-btn">
              Contact Support
            </Link>
          </div>
        </div>
      </div>

          
    </div>
  );
};

export default TrustCenter;
